module.exports = __webpack_public_path__ + "img/3.e9b7de05.png";